angular
	.module('transactionTableArf.components', ['app.services'])
	.component('transactionTableArf', {
		templateUrl: 'ng/components/transactionTableArf/transactionTableArf.view.html',
		controllerAs: 'TransactionTableArfCtrl',
		bindings: {
			identifierAppVendor: '=',
			objectFilter: '<',
			portal: '@'
		},
		controller: function (
			HttpService,
			$location,
			$searchUserService,
			$filter,
			$configService,
			$instantService,
			$transactionFactory,
			$instantLeasingService,
			InstantModel
		) {

			var self = this;
			self.loading = true;
			self.searchUserService = $searchUserService;
			self.configService = $configService;
			self.filter = {
				appIlTransaction: {
					limit: '4',
					offset: 0,
					pageIndex: 1,
					totalPages: 0,
					orderColumnName: 'UPDATE_DATE',
					orderType: 'DESC',
					identifierVendor: $configService.getUser().identifier,
					cfCustomer: '',
					status: '',
					pivaVendor: ''

				}
			};

			self.propMap = propMap;

			self.$onInit = function () {
				self.loader = [];
				self.loaderFirma = [];
				self.objectFilter = self.objectFilter;
				self.mapTransactionStatus = {};
				self.portal = self.portal;
				self.getTransactionStatusList();
				updateOffsetAndSearch();
				self.filter.appIlTransaction.identifierVendor = self.portal ? '' : self.filter.appIlTransaction.identifierVendor
			}

			self.$onChanges = function (changes) {
				self.filter.appIlTransaction.status = self.objectFilter && self.objectFilter.status && self.objectFilter.status.value;
				self.filter.appIlTransaction.cfCustomer = self.objectFilter && self.objectFilter.cf;
				self.filter.appIlTransaction.pivaVendor = self.objectFilter && self.objectFilter.piva;
				updateOffsetAndSearch();
			}




			self.getListIlTransaction = function () {
				$instantService.getListIlTransactionByIdentifierAppVendor(self.filter)
					.then(function (response) {
						var totalCount = response.listAppIlTransactionCount;
						self.filter.appIlTransaction.totalPages = getSTotalPages(totalCount);
						console.log('Risposta dal servizio: ', response);
						self.getListIlTransactionByIdentifierAppVendor = addEmptyRow(response.listAppIlTransaction);
					})
					.catch(function (error) {
						console.log("Errore risposta: ", error);
					})
			}

			//update table getAllSimulations
			self.updateOrderTableSimulation = function (ordColName, ordType) {
				self.filter.appIlTransaction.orderColumnName = ordColName;
				self.filter.appIlTransaction.orderType = ordType;
				self.getListIlTransaction(self.filter);
			}

			self.pageSIndexIndietro = function (value) {
				if (value == 'init') {
					self.filter.appIlTransaction.pageIndex = 1;
				} else {
					if (self.filter.appIlTransaction.pageIndex > 1) {
						self.filter.appIlTransaction.pageIndex--;
					}
				}
				updateOffsetAndSearch();
			}

			self.pageSIndexAvanti = function (value) {
				if (value == 'end') {
					//subito pagina finale
					self.filter.appIlTransaction.pageIndex = self.filter.appIlTransaction.totalPages;
				} else {
					//avanzo +1
					if (self.filter.appIlTransaction.pageIndex < self.filter.appIlTransaction.totalPages) {
						self.filter.appIlTransaction.pageIndex++;
					}
				}
				updateOffsetAndSearch();
			}

			self.checkNotNull = function (codeValue, objStringToCheck) {
				if (objStringToCheck) {
					return $filter('translate')(codeValue);
				}
				return null;
			}

			function updateOffsetAndSearch() {
				self.filter.appIlTransaction.offset = (self.filter.appIlTransaction.pageIndex - 1) * self.filter.appIlTransaction.limit;
				self.getListIlTransaction(self.filter);
			}

			function getSTotalPages(totalCount) {
				//se il resto è zero non va aggiunto +1
				var addPlusOneToTotal = 0;
				var totModuloResult = totalCount % Number(self.filter.appIlTransaction.limit);
				if (totModuloResult > 0) {
					addPlusOneToTotal = 1;
				}
				return (Math.floor(totalCount / Number(self.filter.appIlTransaction.limit))) + addPlusOneToTotal;
			}

			function addEmptyRow(restList) {
				var outputList = [];
				var indexRestList = Number(self.filter.appIlTransaction.limit);
				if (restList != null) {
					outputList = restList;
					indexRestList = Number(self.filter.appIlTransaction.limit) - restList.length;
				}

				if (indexRestList > 0) {
					for (var irl = 0; irl < indexRestList; irl++) {
						outputList.push({});
					}
				}
				return outputList;
			}

			self.getTransactionStatusList = function () {
				HttpService.send(
						"/uni/typedomain/getDomainSet", {
							table: "APP_IL_TRANSACTION",
							column: "TRANSACTION_STATUS"
						},
						false
					).then(function (response) {
						console.log('risposta gettransactinstatutlist : ' + response);
						self.transactionStatusList = response.domainList;

						angular.forEach(self.transactionStatusList, function (item) {
							self.mapTransactionStatus[item.value] = item.name;

						});
						console.log("self.transactionStatusList: ", self.transactionStatusList);
						console.log("self.mapTransactionStatus", self.mapTransactionStatus);
					})
					.finally(function () {
						self.loading = false;
					});
			}

			//DETTAGLIO PRATICHE 

			self.goToPracticeDetail = function (index) {
				self.loaderFirma[index] = true;
				self.instantLeasingService = $instantLeasingService;
				self.instantLeasingService.getPracticeDetail(self.getListIlTransactionByIdentifierAppVendor[index].idWfInstance)
					.then(function (response) {
						if (response) {
							console.log('La risposta della chiamata: ', response);
							response.idWfInstance = self.getListIlTransactionByIdentifierAppVendor[index].idWfInstance;
							$transactionFactory.set(InstantModel.build(response));
							console.log(self.loader[index]);
							self.loaderFirma[index] = false;
							$location.path("/practiceDetail");
						}

					})
					.catch(function (err) {
						console.log('La chiamata è andata in errore: ', err);
						self.loaderFirma[index] = false;
					})
					.finally(function () {
						self.loader[index] = false;
					})
			}
		}
	});